export default {"src":"/_next/static/media/dwn-arrow.d5334b29.svg","height":18,"width":31,"blurWidth":0,"blurHeight":0};